export default "__VITE_ASSET__DgcnVC$B__"